/**
 * Upload limits and accepted types.
 *
 * Moved out of constants.ts so the core's uploader does not import from
 * components/. These are server-enforced limits, not presentation.
 */

export const FILE_UPLOAD_CONSTANTS = {
  MAX_FILES: 5,
  MAX_FILE_SIZE: 25 * 1024 * 1024, // 25MB
  SUPPORTED_TYPES: [
    '.jpg', '.jpeg', '.png', '.gif', '.heic', '.pdf',
    '.mp3', '.m4a', '.wav', '.ogg', '.mp4', '.aac', '.flac',
  ],
  VOICE_NOTE_MAX_DURATION_MS: 60000,
  VOICE_NOTE_MAX_SIZE_BYTES: 5 * 1024 * 1024, // 5MB cap specifically for voice notes
  // Filename prefix used by the recorder; attachment-utils relies on this to classify
  // storage URLs that have lost their audio extension as voice-note audio.
  VOICE_NOTE_FILENAME_PREFIX: 'voice-note-',
  API_ENDPOINTS: {
    getCreateAttachmentsUrl: (serverURL: string, locationId: string, widgetId: string, conversationId?: string) =>
      conversationId
        ? `${serverURL}/chat-widget/attachments-url/${locationId}/${widgetId}/${conversationId}`
        : `${serverURL}/chat-widget/attachments-url/${locationId}/${widgetId}`,
    getChatWidgetAttachmentsUrl: (serverURL: string, locationId: string, widgetId: string, conversationId?: string) =>
      conversationId
        ? `${serverURL}/chat-widget/chat-widget-attachments/${locationId}/${widgetId}/${conversationId}`
        : `${serverURL}/chat-widget/chat-widget-attachments/${locationId}/${widgetId}`,
    getFileUploadLogUrl: (serverURL: string, locationId: string) => `${serverURL}/chat-widget/public/log/${locationId}`,
  },
  NOTIFICATION_DELAY: 5000,
};
